import { Component } from "react"
import PropTypes from "prop-types"
import { PERMISSION_LEVEL, DATE } from "helpers/shapes"
import saveRecentResources from "hocs/saveRecentResources"
import { Outlet } from "react-router-dom"

import "./style.scss"

class ResearchTopicRoot extends Component {
  static propTypes = {
    topic: PropTypes.object,
    modelId: PropTypes.string.isRequired,
    modelAvailability: PropTypes.object,
    setHeader: PropTypes.func.isRequired,
    appHeaderKey: PropTypes.string,
    setModel: PropTypes.func.isRequired,
    permissionLevel: PERMISSION_LEVEL.isRequired,
    portfolioInfo: PropTypes.object,
    portfolioDates: PropTypes.shape({
      earliest: DATE,
      latest: DATE,
    }),
  }

  componentDidUpdate(prevProps) {
    if (prevProps.modelId !== this.props.modelId) {
      this.props.setModel(this.props.modelId)
    }
  }

  render() {
    const { modelId, topic, modelAvailability, setHeader, appHeaderKey, portfolioDates } = this.props
    return <div className="modules_research-topic-root">
      <div className="main">
        <div className="container-fluid">
          <Outlet context={{ modelId, currentTopic: topic, modelAvailability, setHeader, appHeaderKey, portfolioDates }} />
        </div>
      </div>
    </div>
  }
}

export default saveRecentResources(ResearchTopicRoot, "topic.id")
